<template>
    <div>
        <div v-if="hasSearch" class="text-center">
            <input type="text" v-model="searchTerm" placeholder="Meklēt pēc nosaukuma..."
                   class="my-4 px-4 py-2 ds-input" @input="attemptSearch">
        </div>
        <div class="row text-center my-4">
            <div class="col-sm-4 font-weight-bold text-left">Nosaukums</div>
            <div class="col-sm-2 font-weight-bold">Aktīvs</div>
            <div class="col-sm-2 font-weight-bold">Šablons</div>
            <div class="col-sm-4 font-weight-bold text-right">Darbības</div>
        </div>
        <div class="col-sm-12" style="max-height: 552px; overflow-x: hidden;">
            <CategoriesListItem v-for="category in categories"
                            :key="category._id"
                            :category="category"/>
        </div>
    </div>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import * as categoryStoreTypes from '../../vuex/modules/category/category.store-types';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';
    import CategoriesListItem from './CategoriesListItem';

    export default {
        name: 'categories-list',
        components: {CategoriesListItem},
        props: {
            hasSearch: {
                type: Boolean,
                default: false,
            }
        },
        data: () => ({
            searchTerm: '',
            searchTimeout: null,
        }),
        created() {
            this.getCategoryList();
        },
        computed: {
            ...mapGetters('category', {
                /** @type {boolean|*} */
                isLoading: categoryStoreTypes.GET_IS_LOADING,
                /** @type {Categories[]|*} */
                categories: categoryStoreTypes.GET_CATEGORIES,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
            ...mapMutations('category', {
                /** @type {function|*} */
                setCategories: categoryStoreTypes.SET_CATEGORIES,
            }),
            ...mapActions('category', {
                /** @type {function|*} */
                getCategories: categoryStoreTypes.ACTION_GET_CATEGORIES,
            }),
            async getCategoryList(search = '') {

                // if (this.currentCompany._id && !search.length) {
                //     return this.setCategories(this.currentCompany.categories);
                // }

                return this.getCategories({name: search, companyId: this.currentCompany._id});
            },
            /**
             * Search category by name with 500ms delay.
             */
            attemptSearch() {
                clearTimeout(this.searchTimeout);
                this.searchTimeout = setTimeout(() => this.getCategoryList(this.searchTerm), 500);
            },
        },
    }
</script>